import React from "react";
import { Text, AgGrid } from "@jsq/ds/core";
import * as styles from "./styles_vanilla.css";

interface NoRowsOverlayProps {
  api: {
    getFilterModel: () => AgGrid.FilterModel | null;
  };
}

export const NoRowsOverlay: React.FC<NoRowsOverlayProps> = ({ api }) => {
  const filterModel = api.getFilterModel();
  const hasFiltersApplied = filterModel && Object.keys(filterModel).length > 0;

  const message = hasFiltersApplied
    ? "No entities match the selected filters"
    : "To view entities, first select at least one filter using the Filters tab";

  return (
    <div role="presentation" className={styles.overlayStyle}>
      <Text variant="regular-md" align="center">
        {message}
      </Text>
    </div>
  );
};
